import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row items-center py-2 container"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 3,
  class: "py-8 flex flex-row items-center container w-full"
}
const _hoisted_5 = { class: "flex flex-row ml-4 bg-white w-full" }
const _hoisted_6 = { class: "space-y-5 w-full" }
const _hoisted_7 = { class: "sm:flex flex-row items-center justify-between w-full" }
const _hoisted_8 = { class: "text-2xl" }
const _hoisted_9 = { class: "flex flex-row items-center" }
const _hoisted_10 = { class: "flex items-center pr-5 space-x-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
  })
], -1)
const _hoisted_13 = { class: "container py-8" }
const _hoisted_14 = { class: "sm:flex space-x-5 space-y-6 sm:space-y-0 justify-center" }
const _hoisted_15 = { class: "sm:w-8/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ErrorPage = _resolveComponent("ErrorPage")!
  const _component_Link = _resolveComponent("Link")!
  const _component_CandidateInfo = _resolveComponent("CandidateInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Divider)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_Loading, {
            active: _ctx.isLoading,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
            "can-cancel": false,
            loader: "spinner",
            color: "#8908F9",
            width: 128,
            height: 128,
            opacity: 0.5,
            "is-full-page": true
          }, null, 8, ["active", "opacity"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.error && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_ErrorPage, { key: 2 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.jobStore.title), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Link, {
                      label: "Return to Job List",
                      variant: "outlined",
                      sizeLabel: "text-sm",
                      to: "/jobs"
                    }, {
                      startIcon: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Link, {
                      label: "Return to Job Candidates",
                      variant: "outlined",
                      sizeLabel: "text-sm",
                      to: `/job-candidates-detail?id=${_ctx.jobId}&by_stage_name=Talent+Pool`
                    }, {
                      startIcon: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ])
            ])
          ])
        ])),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: _normalizeClass([_ctx.showOption === '' ? 'h-screen' : 'h-full', "min-h-screen z-10 inset-0 bg-black bg-opacity-50"])
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_CandidateInfo, {
                  userInfo: _ctx.userInfo,
                  onResetSelected: _ctx.resetSelected,
                  candidateId: _ctx.userInfo?.candidate_id,
                  key: "create"
                }, null, 8, ["userInfo", "onResetSelected", "candidateId"])
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}